<template>
  <div class="contentLoging">
    <div class="login">
      <div class="title">安全中心账号登录</div>
      <van-field v-model="phone" label="手机号" placeholder="请输入手机号" />
      <van-field
        v-model="sms"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button
            color="#ffa623"
            size="small"
            type="primary"
            @click="sendCode"
            class="sencode"
            >{{ codeBtn }}</van-button
          >
        </template>
      </van-field>
      <van-button
        class="btnlogin"
        type="primary"
        size="large"
        color="#ffa623"
        @click="login"
        >登录</van-button
      >
    </div>
  </div>
</template>

<script>
import apiFun from "../../servers/apiFun";
import comTools from "../../assets/js/until";
export default {
  data() {
    return {
      height: "",
      phone: "",
      sms: "",
      number: 0,
      timer: null,
      codeBtn: "发送验证码",
    };
  },
  methods: {
    login() {
      var reg = new RegExp("^1[3-9][0-9]{9}$");
      if (reg.test(this.phone)) {
        let data = {
          type: "number_login",
          mobile: this.phone,
          code: String(this.sms),
        };
        apiFun.CenterLogin(comTools.jiam(data)).then((res) => {
          if (res.code == 200) {
            this.$cookies.set("login_time",res.data.login_time,"7d"); 
            this.$cookies.set("mobile",res.data.mobile,"7d"); 
            this.$cookies.set("is_open",res.data.is_open,"7d"); 
            // this.$cookies.set("user_info",JSON.stringify(res.data.user_info),"7d"); 

            // localStorage.setItem('login_time',res.data.login_time)
            // localStorage.setItem('mobile',res.data.mobile)
            // localStorage.setItem('is_open',res.data.is_open)
            localStorage.setItem('user_info',res.data.user_info)
            this.$router.push({
              name: 'SecurityCenter'
            });
          } else {
            this.$toast.fail(res.msg);
          }
        });
      } else {
        this.$toast.fail("请输入正确的手机号码！");
      }
    },
    sendCode() {
      var reg = new RegExp("^1[3-9][0-9]{9}$");
      console.log(reg.test(this.phone));
      if (this.number > 0) {
        this.$toast.fail("请勿频繁发送验证码！");
        return;
      } else {
        if (reg.test(this.phone)) {
          let data = {
            type: "number_login",
            mobile: this.phone,
          };
          apiFun.SendCode(comTools.jiam(data)).then((res) => {
            if (res.code == 200) {
              this.number = 60;
              this.timer = setInterval(() => {
                this.codeBtn = this.number + "s";
                this.number--;
                if (this.number == 0) {
                  clearInterval(this.timer);
                  this.codeBtn = "发送验证码";
                  this.number = 0;
                }
              }, 1000);
              this.$toast.success(res.msg);
            } else {
              this.$toast.fail(res.msg);
            }
          });
        } else {
          this.$toast.fail("请输入正确的手机号码！");
        }
      }
    },
  },
  created() {},
};
</script>

<style lang="less"  scoped>
.sencode {
  width: 22vw;
}
.btnlogin {
  border-bottom-left-radius: 3vw;
  border-bottom-right-radius: 3vw;
  font-weight: 600;
}
.contentLoging {
  .login {
    width: 90%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #efefef;
    .title {
      height: 12vw;
      line-height: 12vw;
      font-size: 4.5vw;
      font-weight: 600;
      text-align: center;
      background: #ffa623;
      color: #fff;
      border-top-left-radius: 3vw;
      border-top-right-radius: 3vw;
    }
  }
}
</style>